import { put, select } from 'typed-redux-saga';

import { updateTeleMessengerRedirectInfo } from '..';
import { isMobileUa } from '../../uatraits';
import { selectTeleMessengerActualRedirectUrl, selectTeleMessengerRedirectUrl } from '../selectors';

export function* teleMessengerRedirectSaga() {
    const actualUrl = yield* select(selectTeleMessengerActualRedirectUrl);
    const isMobile = yield* select(isMobileUa);
    if (!isMobile && actualUrl) {
        window.location.href = actualUrl;
    }
}

export function* actualizeTeleMessengerRedirectSaga() {
    const url = yield* select(selectTeleMessengerRedirectUrl);
    const actualUrl = yield* select(selectTeleMessengerActualRedirectUrl);
    if (actualUrl && url !== actualUrl) {
        yield* put(
            updateTeleMessengerRedirectInfo({
                url: actualUrl,
                withAppendingHash: undefined,
            })
        );
    }
}
